import {join} from "./data";

export const applyClassName = (className, props = {}) => {
    const classNames = join([className, props.className], ' ');
    return classNames ? {className: classNames} : {};
};
